<template>
    <el-dialog
        v-drag
        class="manage-driver-add-dialog"
        :title="'委派函上传'"
        :visible.sync="visible"
        width="1000px"
        style="padding: 0 50px 50px 0"
        :before-close="close"
    >
        <el-table
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column
                v-for="(item, index) in column"
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                    <span class="btn-item" @click="preview(scope.row)">预览</span>
                    <span class="btn-item" @click="download(scope.row)">下载</span>
                    <span class="btn-item" @click="back(scope.row)" v-if="scope.row.delegateStatus === STATUS['3']">撤回</span>
                    <span class="btn-item" @click="del(scope.row)"  v-if="scope.row.delegateStatus === STATUS['2']">删除</span>
                    <span class="btn-item" @click="pushFn(scope.row)"  v-if="scope.row.delegateStatus === STATUS['2']">推送</span>
                </template>
            </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
        </span>
        <Preview
            :attachmentList="attachmentList"
            v-if="attachmentShow"
            :attachmentShow.sync="attachmentShow"
            :rowData="rowData"
        ></Preview>
    </el-dialog>
</template>

<script>
import Preview from '../../../../../../components/viewAttachment.vue';
import { getDelegateList, deleteDelegate, electronicSealConUndo, electronicSealCon } from '../../../../../../api/register/driver.js';
const STATUS = {
    '2': 2, // 待推送
    '3': 3 // 盖章中
};
export default {
    props: {
        visible: {
            type: Boolean,
            default() {
                return false;
            }
        },
        id: [String, Number]
    },
    components: { Preview },
    data() {
        return {
            STATUS,
            attachmentShow: false,
            attachmentList: [],
            rowData: {},
            tableData: [],
            column: [{
                prop: 'delegateNo',
                label: '委派函编码'
            }, {
                prop: 'delegateStartTime',
                label: '委派开始日期'
            }, {
                prop: 'delegateEndTime',
                label: '委派结束日期'
            }, {
                prop: 'delegateStatusNameCn',
                label: '状态'
            }, {
                prop: 'signingDate',
                label: '签订时间'
            }, {
                prop: 'documentSourceNameCn',
                label: '单据来源'
            }, {
                prop: 'certificatePageTypeNameCn',
                label: '证件页'
            }, {
                prop: 'supplierPageDelegateNo',
                label: '供应商页编码'
            }]
        };
    },
    watch: {
        visible(val) {
            if (val) {
                this.loadList();
            }
        }
    },
    methods: {
        loadList() {
            getDelegateList(this.id).then(res => {
                if (res && res.code === '0') {
                    this.tableData = res.data;
                }
            });
        },
        close() {
            this.$emit('update:visible', false);
        },
        download(row) {
            window.open(row.fileUrl);
        },
        del(row) {
            deleteDelegate(row.delegateNo).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('成功删除！');
                    this.loadList();
                }
            });
        },
        pushFn(row) {
            electronicSealCon(row.delegateNo).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('成功推送！');
                    this.loadList();
                }
            });
        },
        back(row) {
            electronicSealConUndo(row.delegateNo).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('成功撤回！');
                    this.loadList();
                }
            });
        },
        preview(row) {
            this.attachmentShow = true;
            this.rowData = {
                downUrl: row.fileUrl,
                fileName: row.fileName,
                fileId: row.fileId
            };
        }
    }
};
</script>

<style lang="less">
.btn-item {
    display: inline-block;
    padding: 0 5px;
    cursor: pointer;
    color: #00bcbf;
}
</style>